import { getExceptionHandler } from "@alfa-web-tools/requests-utils";
import { UseNavigateReturnType } from '@alfa-retail-react/components/navigate-hook';

import { UnauthorizedException } from 'app/api/exception/UnauthorizedException';
import {
    REDIRECT_PAGE_URL,
    RedirectPageState,
} from 'app/logic/pages/redirect/RedirectPage';

interface IUnauthorizedExceptionHandler {
    navigate: UseNavigateReturnType;
    phoneNumber: string;
}

export const unauthorizedExceptionHandlerOnSubmitData = ({
    navigate,
    phoneNumber,
}: IUnauthorizedExceptionHandler) => {
    return getExceptionHandler(
        UnauthorizedException.NAME,
        async (exception: UnauthorizedException) => {
            const authorizeUrl = await exception.getAuthorizeUrl();
            return navigate<RedirectPageState>(REDIRECT_PAGE_URL, {
                authorizeUrl,
                phoneNumber,
            });
        },
    );
};

export const unauthorizedExceptionHandlerOnLoadData = ({
    navigate,
    phoneNumber,
}: IUnauthorizedExceptionHandler) => {
    return getExceptionHandler(
        UnauthorizedException.NAME,
        async (exception: UnauthorizedException) => {
            const authorizeUrl = await exception.getAuthorizeUrl();
            return navigate<RedirectPageState>(REDIRECT_PAGE_URL, {
                authorizeUrl,
                phoneNumber,
            });
        },
    );
};
